/** Same rule as the API: only http(s) links. */
export function isHttpUrl(value: string): boolean {
  try {
    const url = new URL(value.trim());
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

/** Accepts "www.shop.de/x" as a convenience and turns it into "https://www.shop.de/x". */
export function normalizeUrl(value: string): string {
  const trimmed = value.trim();
  if (trimmed === '' || /^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

/** Short, readable caption for a link without label: the host name without "www.". */
export function linkCaption(label: string | null | undefined, url: string): string {
  if (label?.trim()) return label.trim();
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}
